import React, { useContext, useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { sendForApproval } from '../../redux/features/student/studentSlice';
import { ProcessingButton } from '../../shared/ProcessingButton';
import AppContext from '../../storage/AppContext';
// import MultiSearchSelect from "react-search-multi-select";
import Select from "react-select";
import useToast from '../../shared/Toast';


function AddDiscountModal({addDiscountModalDetails, showAddDiscountModal, setShowAddDiscountModal, selectedAcademicYear}) {
    
    const [term, setTerm] = useState("");
    const [admissions, setAdmissions] = useState([]);
    const [feeAmount, setFeeAmount] = useState("")

    const [amountAfterDiscount, setAmountAfterDiscount] = useState("")
    const [discountedAmount, setDiscountedAmount] = useState("")
    const [discountPercentage, setDiscountPercentage] = useState()

    let isEmptyFields = false

    const dispatch = useDispatch()

    const showToast = useToast()

    const appContext = useContext(AppContext);

    const userDetails = appContext?.userDetails

    const studentsDetails = useSelector(state => state?.student?.allStudentsDetails)
    const discountApprovalDetails = useSelector(state => state.student.sendForApprovalDetails)

    const studentNames = studentsDetails?.data?.filter((eachStudent) => {
        let termExists = false
        for(let eachTerm of eachStudent.termFee){
            if(Object.keys(eachTerm)?.[0] === term && eachTerm?.[term]?.paymentStatus === "Unpaid"){
                termExists = true
                break
            }
        }
        if(termExists) return eachStudent
    }).map((eachStudent) => {
        return {label:eachStudent.name+" : "+eachStudent.admissionNumber,value:eachStudent.admissionNumber}
    })

    const values = [{ label: "Select All", value: "all" }, ...studentNames]

    const customStyles = {
        control: base => ({
          ...base,
          maxHeight: 150,
          overflow:"auto"
        })
      };

    const handleChange = arr => {
        console.log('arrrrr', arr)
        const selectedAdmissionNumbers = arr.map((e) => e.value)
        console.log("term", term, studentsDetails, 'selectedAdmissionNumbers ==>', selectedAdmissionNumbers)
        const selectedStudents = selectedAdmissionNumbers.map((admissionNumber) => studentsDetails?.data?.find((eachStudent) => admissionNumber === eachStudent.admissionNumber))
        console.log('selectedStudents ==>', selectedStudents)
        const fees = []
        selectedStudents.map((eachStudent) => {
            let termDetails 
            eachStudent.termFee.map((eachTerm) => {
                if(Object.keys(eachTerm)?.[0] === term){
                    termDetails = eachTerm[Object.keys(eachTerm)?.[0]]?.amount
                }
            }) 
            if(termDetails) fees.push(termDetails)
        })
        console.log('fees', fees)
        const feeMatch = fees.every( (val, i, arr) => val === arr[0] )
        
        if(!feeMatch) {return showToast({message: "Fee Amount of selected students doesn't match", type: 'error'})}
        setFeeAmount(fees[0])
        setAdmissions(arr)
        setAmountAfterDiscount("")
        setDiscountPercentage("")
        setDiscountedAmount("")
    };

    const onChangeAmountAfterDiscount = (event) => {
        console.log('fah', (parseInt(event.target.value) < parseInt(feeAmount)),parseInt(event.target.value),  parseInt(feeAmount))
        if(!isNaN(event.target.value)){
            setAmountAfterDiscount(event.target.value)
            const discountedAmountInFunction = parseInt(feeAmount) - parseInt(event.target.value)
            setDiscountedAmount(discountedAmountInFunction)
            const discountPercentageInFunction = (discountedAmountInFunction/ parseInt(feeAmount)) * 100
            setDiscountPercentage(discountPercentageInFunction)
        }
    }


    const onClickSendApproval = () => {
        if(isEmptyFields === false){
        if(term === "" || amountAfterDiscount === "" || admissions.length === 0){
            showToast({message: "Please fill all the fields", type: 'error'})
            const loginIntervalId = setInterval(() => {
                clearInterval(loginIntervalId)
                isEmptyFields = false
            }, 3200)
            isEmptyFields = true
        }else{ 
            let message;
            const type = "discountApproval"
            const branch =  userDetails?.data?.branch;
            const admissionNumberValues = admissions?.map(each => each.value)
            const admissionNumbers = [];
            admissionNumberValues.map(each => {
                for(let eachStudent of studentsDetails?.data){
                     if(eachStudent.admissionNumber === each){
                        eachStudent.termFee.map(eachTerm => {
                            let key = Object.keys(eachTerm)?.[0]
                            if(key === term){
                               if((!eachTerm[term].discountedAmount || eachTerm[term].discountedAmount === "Rejected") && eachTerm[term].paymentStatus === "Unpaid"){
                                  admissionNumbers.push(each)
                               }
                            }
                        })
                     }
                }
            })

            // let a = admissions.filter(each => {
            //     return admissionNumbers.includes(each.value)
            // })

            let a = []
            for (let eachStudent of studentsDetails.data) {
                    if(admissionNumbers.includes(eachStudent.admissionNumber)){
                        a.push(`${eachStudent.name} : ${eachStudent.admissionNumber} of Class : ${eachStudent.class}, Section : ${eachStudent.section}, Roll No : ${eachStudent.rollNo}`)
                    }
            }
            
            if(admissionNumbers?.length === studentsDetails?.data?.length){
                message = `${userDetails?.data?.role} has sent approval request for ${Math.round(discountPercentage * 100) / 100}% Discount of ${term} for All Students`;
            }else{
                message = `${userDetails?.data?.role} has sent approval request for ${Math.round(discountPercentage * 100) / 100}% Discount of ${term} for ${a?.map(each => each).join(" and ")}`;
            }
            console.log("onClickSendApproval ::::::::",{branch, term, discount: discountPercentage, message, type, admissionNumbers,admissions:a, role: userDetails?.data?.role, academicYear: selectedAcademicYear})
            if(admissionNumbers.length === 0){
                showToast({message: "Select eligible students", type: 'error'})
                const loginIntervalId = setInterval(() => {
                    clearInterval(loginIntervalId)
                    isEmptyFields = false
                }, 3200)
                isEmptyFields = true
            }else{
                dispatch(sendForApproval({branch, term, discount: discountPercentage, message, type, admissionNumbers, admissions:a, role: userDetails?.data?.role, academicYear: selectedAcademicYear}))
            }
        }}
    }

  return (
    <Modal size="lg" show={showAddDiscountModal} onHide={() => { setShowAddDiscountModal(!showAddDiscountModal); setTerm(""); setAmountAfterDiscount(""); setAdmissions([]); setDiscountedAmount(""); setDiscountPercentage("") }} >
            <Modal.Header closeButton>
                <Modal.Title> <p>Add Discount</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className="form-group">
                    <label className="control-label" htmlFor="term">Term</label>
                    <select style={{ backgroundImage: 'none' }} onChange={(event) => setTerm(event.target.value)} name={"term"} placeholder="Select the Term" className="form-control mb-3" aria-label="Default select example">
                        <option disabled selected hidden value="" >Select The Term</option>
                        {addDiscountModalDetails?.map((each,i) => {
                            return <option key={i} value={each}>{each}</option>
                        })}
                    </select>
                </div>

                {term !== "" && <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Students</label>
                    {/* <MultiSearchSelect
                        id="students"
                        name="students"
                        searchable={true}
                        showTags={true}
                        multiSelect={true}
                        width="100%"
                        onSelect={handleChange}
                        options={values}
                        // primaryColor="#ffffff"
                    /> */}
                    <Select
                        maxMenuHeight='200px'
                        options={values}
                        isClearable={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti
                        value={admissions}
                        onChange={(selected) => {
                            selected.length &&
                            selected.find((option) => option.value === "all")
                            ? handleChange(values.slice(1))
                            : !true
                            ? handleChange((selected && selected.value) || null)
                            : handleChange(selected);
                        }}
                        styles={customStyles}
                        minHeight="100px"
                        />

                </div>}
                
                {admissions.length > 0 && term !== "" &&
                    <>
                        <div className="form-group">
                            <label className="control-label" htmlFor="feeAmount">Amount</label>
                            <input readOnly defaultValue={feeAmount} type="number" placeholder='' autoComplete='off'  className="form-control" id='feeAmount' name='feeAmount' required />
                        </div>

                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div className="form-group">
                                <label className="control-label" htmlFor="amountAfterDiscount">Enter Amount After Discount</label>
                                <input value={amountAfterDiscount} onChange={onChangeAmountAfterDiscount} type="number" placeholder='' autoComplete='off'  className="form-control" id='amountAfterDiscount' name='amountAfterDiscount' required />
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="discountedAmount">Discount Amount</label>
                                <input readOnly defaultValue={discountedAmount} type="number" placeholder='' autoComplete='off'  className="form-control" id='discountedAmount' name='discountedAmount' required />
                            </div> <div className="form-group">
                                <label className="control-label" htmlFor="discountPercentage">Discount Percentage</label>
                                <input readOnly defaultValue={discountPercentage} type="number" placeholder='' autoComplete='off'  className="form-control" id='discountPercentage' name='discountPercentage' required />
                            </div>
                        </div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowAddDiscountModal(false); setTerm(""); setAmountAfterDiscount(""); setAdmissions([]); setDiscountedAmount(""); setDiscountPercentage("")}}>
                    Cancel
                </Button>
                {/* <Button variant="primary" onClick={onClickSendApproval}>
                    Send For Approval
                </Button> */}
                <ProcessingButton
                    onBtnClick={onClickSendApproval}
                    btnText={discountApprovalDetails.status === 'loading' ? 'Sending...' : 'Send For Approval'}
                    isLoading={discountApprovalDetails.status === 'loading'}
                    styles="btn-color text-center mt-1 text-white"
                    variant="primary"
                />
            </Modal.Footer>
        </Modal>
  )
}

export default AddDiscountModal